import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["kind", "value", "input"]

  connect() {
    this.toggle()
  }

  toggle() {
    const limited = this.kindTarget.value === "limited"

    this.valueTarget.classList.toggle("d-none", !limited)
    this.inputTarget.disabled = !limited
    this.inputTarget.required = limited
  }
}
